/**
 * Created by ken on 17/4/21.
 */

export default {
  // 公共返回码:200~999
  201: "签名错误",
  202: "请求参数错误",
  203: "必填参数为空",
  204: "时间戳参数为空",
  205: "请求受限",
  207: "数据库异常",
  208: "签名生成错误",
  209: "文件上傳出錯",

  300: "时间戳参数访问超时",
  301: "JSON转换异常",
  302: "参数格式转换错误",
  303: "Email is not valid.",
  304: "数据校验不通过",
  777: "找不到token失效",
  778: "找不到token",

  999: "未知系统错误",

  // 1000~1999 user 模块 相关error
  1007: "邮箱已经存在",
  1010: "邮箱不存在",
  1011: "密码错误",
  1012: "注册来源有误",
  1013: "用户类型错误",
  1014: "用户Id类型错误",
  1015: "用户不存在",
  1017: "角色Id 不正确",
  1018: "没有权限，请先激活邮箱，并联系管理员授权后再重新登录！",


  // 2000~2999 role 模块 相关error
  2000: "删除角色失败",
  2001: "角色不存在",

  // 3000~3999 Tag 模块 相关error
  3000: "Tag类型不正确",


  // 4000~4999 Category 模块 相关error
  4001: "Tag类型不正确",
  4002: "类别包含子类别,不能删除!",
  4003: "类别下有商品,不能删除!",

  // 8000~8999 订单模块相关error
  8000: "SKU不可售",
  8001: "SKU库存不足",
  8002: "物流不可达",
  8003: "超出优惠限购数量",
  8004: "订单不存在",
  8005: "订单状态不符合当前操作要求",
  8006: "订单中商品信息不符",
  8007: "优惠券条件不满足",
  8008: "优惠券不可用",

  // Product模块错误码
  9001: "After tax price no less than sale price",
  9002: "吊牌价必须大于采购价",

  //company 模块错误码
  10003: "该公司等级已被使用",
  10004: "不能重复提交申请",

  //promotion模块错误码
  14001: "与其他直降或折扣活动时间重叠了",
  14006: "与其他直降或折扣活动时间重叠了",
  14007: "与其他满包邮活动时间重叠了",
  14004: "与其他秒杀活动开始时间重叠了",

  //Dashboard 账号中心
  3003: "验证码错误"

};




// WEBPACK FOOTER //
// ./src/assets/js/error_parameters.js